<template>
  <v-container>
    <v-text-field
      ref="searchInput"
      placeholder="Tag name/Arranger"
      v-model="searchTerm"
      v-on:keyup.enter="performSearch"
      class="title"
    ></v-text-field>

    <v-btn block color="primary" @click="random">Random Tag!</v-btn>
  </v-container>
</template>

<script>
import { parseString } from "xml2js";

const PROXY_URL = "https://rocky-ocean-85683-94e757970aca.herokuapp.com";

export default {
  props: ["id"],

  data() {
    return {
      searchTerm: ""
    };
  },

  mounted() {
    if (this.id) {
      this.getTags(this, `http://www.barbershoptags.com/api.php?id=${this.id}`);
    }
  },

  methods: {
    getTags(self, url) {
      self.$refs.searchInput.blur();
      self.$store.commit("setIsSearching", true);

      self.$http.get(`${PROXY_URL}/${url}`).then(response => {
        parseString(response.body, (err, result) => {
          if ((result.tags === undefined) | !result.tags.tag) {
            self.$store.commit("setIsSearching", false);
            self.$store.commit("setSearchResults", []);

            return;
          }

          let results = result.tags.tag.map(t => {
            return {
              id: t.id[0],
              title: t.Title[0].replace(/^'|'$/g, ""),
              key: t.WritKey[0],
              arranger: t.Arranger[0],
              rating: Math.round(parseFloat(t.Rating[0])),
              parts: t.Parts[0],
              dots: t.SheetMusic[0]._,
              all: t.AllParts[0]._,
              bari: t.Bari[0]._,
              bass: t.Bass[0]._,
              lead: t.Lead[0]._,
              tenor: t.Tenor[0]._
            };
          });

          self.$store.commit("setIsSearching", false);
          self.$store.commit("setSearchResults", results);
        });
      });
    },

    performSearch() {
      this.getTags(
        this,
        `http://www.barbershoptags.com/api.php?n=100&q=${this.searchTerm}`
      );
    },

    random() {
      let start = Math.floor(Math.random() * 4000) + 1;

      this.getTags(
        this,
        `http://www.barbershoptags.com/api.php?n=1&start=${start}`
      );
    }
  }
};
</script>
